<script setup>
import { useForm } from "@/form";
import UpdateAutomaticPostsSettingsForm from "./Partials/UpdateAutomaticPostsSettingsForm.vue";
import UpdateAutomaticPostsTemplateForm from "./Partials/UpdateAutomaticPostsTemplateForm.vue";
import Layout from "./Partials/Layout.vue";

const settings = await useForm().post("linking_automatic_posts_index");
</script>

<template>
    <Layout>
        <div class="flex flex-col flex-1 py-8 space-y-6 sm:px-6 lg:px-8">
            <UpdateAutomaticPostsSettingsForm :settings="settings" />
            <UpdateAutomaticPostsTemplateForm :settings="settings.template" />
        </div>
    </Layout>
</template>
